var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-container"},_vm._l((_vm.services),function(item,i){return _c('router-link',{key:i,attrs:{"to":item.to}},[_c('van-image',{staticClass:"service",attrs:{"src":item.icon}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }